// import { useOrgStore } from '@/stores/org-store';
import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '../../utils/api-request';
import { Source, SourceOrder } from '@/types/source-types';

interface GetCollectionSourcesResponse {
  data?: {
    status: string;
    organization_id: string;
    collection: string;
    order_by: SourceOrder;
    total_files: number;
    files: Source[];
  };
  detail?: string;
}

interface GetCollectionSourcesProps {
  id?: string;
  collection: string;
  orderBy?:
    | 'name_asc'
    | 'name_desc'
    | 'upload_desc'
    | 'upload_asc'
    | 'size_desc'
    | 'size_asc';
  includeQuality?: boolean;
  s3TagsFilter?: string;
}

export const getCollectionSources = async ({
  id = '',
  collection,
  orderBy = 'name_asc',
  includeQuality = false,
  s3TagsFilter,
}: GetCollectionSourcesProps): Promise<GetCollectionSourcesResponse> => {
  const orgId = id || useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  if (!collection) {
    throw new Error('Collection name is required');
  }

  const searchParams = new URLSearchParams({
    order_by: orderBy,
  });

  if (includeQuality) {
    searchParams.set('include_quality', 'true');
  }

  if (s3TagsFilter) {
    searchParams.set('s3_tags_filter', s3TagsFilter);
  }

  const response = await apiRequest<GetCollectionSourcesResponse>({
    url: `/uploads/${orgId}/${collection}?${searchParams.toString()}`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to fetch data sources',
    };
  }

  return response as GetCollectionSourcesResponse;
};
